export enum AccountPages {
  Overview = 'Account Overview',
  Profile = 'Account Profile',
}

export enum ProfileFormFields {
  Month = 'Month',
  Day = 'Day',
  Year = 'Year',
  FirstName = 'First Name',
  LastName = 'Last Name',
  Email = 'Email',
  Gender = 'Gender',
  DateOfBirth = 'Date Of Birth',
}

// TO DO:  merge ProfileFormFields & ProfileFormInputs into one

export enum ProfileFormInputs {
  FirstName = 'firstName',
  LastName = 'lastName',
  Email = 'email',
  DateOfBirth = 'dob',
  Gender = 'gender',
}

export type FormInputsPath =
  | ProfileFormInputs.FirstName
  | ProfileFormInputs.LastName
  | ProfileFormInputs.DateOfBirth
  | ProfileFormInputs.Email
  | ProfileFormInputs.Gender
  | `root.${string}`
  | 'root'

export const DatePickerDropdownFields = [ProfileFormFields.Month, ProfileFormFields.Day, ProfileFormFields.Year]
